import { FC, useState } from "react";

const BaseUserAvatar: FC<{
  logoUrl?: string;
  userName: string;
  customStyles?: string;
  isPlaceholder?: boolean;
  title?: string;
}> = ({ isPlaceholder = false, logoUrl, userName, customStyles, title }) => {
  const userHasAvatar =
    logoUrl && logoUrl !== undefined && logoUrl !== null && logoUrl !== "";

  return (
    <div className={`user__avatar ${customStyles ? customStyles : ""}`}>
      <div className="avatar">
        <div className="avatar__content">
          {userHasAvatar ? (
            <img
              title={title ? title : ""}
              src={logoUrl || ""}
              alt={`Avatar for ${userName}`}
            />
          ) : (
            <div className="avatar__letter">
              <span>{userName && userName.slice(0, 1)}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default BaseUserAvatar;
